<template>
  <div class="line-through" :class="sizes[size]" data-qa="priceOriginal">
    {{ price }}
  </div>
</template>

<script setup lang="ts">
import { tw } from '@backmarket/utils/string/tw'

import { type PriceProps } from './types'

// Sizes are completely arbitrary and might need revision
const sizes = {
  small: tw`text-[1.2rem]`,
  medium: tw`text-[1.4rem]`,
  large: tw`text-[2rem]`,
}

withDefaults(defineProps<PriceProps>(), {})
</script>
